// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/node_modules/_@umijs_runtime@3.5.43@@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index')}),
    "routes": [
      {
        "path": "/erpdown",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ERPDown' */'@/pages/ERPDown')}),
        "exact": true
      },
      {
        "path": "/erpup",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ERPUp' */'@/pages/ERPUp')}),
        "exact": true
      },
      {
        "path": "/wcsdown",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WCSDown' */'@/pages/WCSDown')}),
        "exact": true
      },
      {
        "path": "/wcsup",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WCSUp' */'@/pages/WCSUp')}),
        "exact": true
      },
      {
        "path": "/config",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__config__Config' */'@/pages/config/Config')}),
        "exact": true
      },
      {
        "path": "/notify",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notify__Notify' */'@/pages/notify/Notify')}),
        "exact": true
      },
      {
        "path": "/exportAndImport",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__exportAndImport__ExportAndImport' */'@/pages/exportAndImport/ExportAndImport')}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
